import { createRoot } from "react-dom/client";
import { ThemeProvider } from "next-themes";
import App from "./App.tsx";
import "./index.css";

// Detect Capacitor native context
const isCapacitor = !!(window as any).Capacitor?.isNativePlatform?.();

// Register service worker for PWA — only in production (published domain), never in Capacitor
const isProduction = !isCapacitor && window.location.hostname.endsWith(".lovable.app") && !window.location.hostname.includes("-preview--");

if ("serviceWorker" in navigator) {
  if (isProduction) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  } else {
    // In preview/dev: unregister old workers and clear caches
    navigator.serviceWorker.getRegistrations().then((regs) =>
      regs.forEach((r) => r.unregister())
    );
    if ("caches" in window) {
      caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
    }
  }
}

createRoot(document.getElementById("root")!).render(
  <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
    <App />
  </ThemeProvider>
);
